<div class="goUp" [ngClass]="{'show':showGoUp}" (click)="scrollUp()" (scroll)="onScroll($event)">
  <p class="icon">>></p>
</div>
